import classnames from "classnames";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";

import StatusBarButton from "../StatusBarButton/StatusBarButton";

// tslint:disable-next-line:no-var-requires
const style = require("./TopControlPanel.scss");

interface TopControlPanelProps extends RouteComponentProps {
    readonly sendBackAction: () => void;
}

export function TopControlPanel(props: TopControlPanelProps & WithTranslation) {
    if (shouldDisplayTopControlPanelFor(window.location.pathname)) {
        return renderTopControlButtons(props);
    } else {
        return null;
    }
}

function renderTopControlButtons(
    props: TopControlPanelProps & WithTranslation
) {
    const wrapperClass = classnames(
        style.top,
        getSpecialStylesForLang(props.i18n.language)
    );
    return (
        <div className={wrapperClass}>
            <Link to="/">
                <div className={wrapperClass}>
                    <StatusBarButton className={classnames(style.home)}>
                        {props.t("HOME")}
                    </StatusBarButton>
                </div>
            </Link>
            <StatusBarButton
                onClick={props.sendBackAction}
                className={classnames(style.back)}
            >
                {props.t("BACK")}
            </StatusBarButton>
        </div>
    );
}

function shouldDisplayTopControlPanelFor(pathname: string) {
    if (pathname === "/") {
        return false;
    }
    if (pathname.match("/screen-saver.*")) {
        return false;
    }
    return true;
}

function getSpecialStylesForLang(language: string): any {
    switch (language) {
        case "tr":
            return style.trFonts;
        case "el":
            return style.elFonts;
        case "hr":
            return style.hrFonts;
        default:
            return null;
    }
}

export default withRouter(withTranslation("topControlPanel")(TopControlPanel));
